<div class="m-2">
    @if (confirmationRequired) {
    <div>
        Your appointment is being reviewed by the clinic and you will receive a confimation email once it has been
        accepted.
    </div>
} @else {
    <div>
        Your appointment has been receieved by the clinic and you will receive a confimation email.
    </div>
}


    <div class="row my-5">
        <div class="col-sm-5">
            <button mat-raised-button class="w-100" (click)="buttonPress('book-another')"
                color="primary">Book another appointment</button>
        </div>
        <div class="col-sm-2"></div>
        <div class="col-sm-5 mb-2">
            <button mat-raised-button class="w-100" (click)="buttonPress('logout')"
                color="primary">Logout</button>
        </div>
    </div>

<!--
    <div *ngIf="patient.NewPatient">
        <div class="mt-3">In order to save time on your arrival at the clinic please complete your personal details
            in
            advance:</div>
        <button mat-raised-button class="btn btn-lg m-3" (click)="buttonPress('details')" color="primary">Complete
            Details</button>
    </div>
-->
</div>